/* src/app/dynamic-forms/form-view/form-view-select/form-view-select.component.css */
.mat-mdc-form-field {
  display: inline;
  width: 100%;
}
/*# sourceMappingURL=form-view-select.component.css.map */
